export default "/kiban/_next/static/images/massProductionSimulation-9c4322ef27be3c2c6f352969d1c1e77a.png";